export const WEB_MOBILE_MEMBERSHIP_CHANNEL = 'WEB_MOBILE';
export const WEB_PC_MEMBERSHIP_CHANNEL = 'WEB_PC';

export type MembershipChannel =
  | typeof WEB_MOBILE_MEMBERSHIP_CHANNEL
  | typeof WEB_PC_MEMBERSHIP_CHANNEL;

type PendingSubscriptionPayloadInput = {
  cplatToken: string;
  channel: MembershipChannel;
};

export const createPendingSubscriptionPayload = ({
  cplatToken,
  channel,
}: PendingSubscriptionPayloadInput) => {
  return {
    cplatToken,
    channel,
  };
};

export const getRegisterPendingSubscriptionErrorMessage = (code?: string, message?: string) => {
  if (code === '530' || code === 'ERROR_NO_DATA') {
    return '결제수단 등록 후 다시 시도해 주세요.';
  }

  if (code === '522' || code === 'ERROR_INVALID_TOKEN') {
    return '로그인이 만료되었습니다. 다시 로그인해 주세요.';
  }

  if (code === '632' || code === 'ERROR_DUPLICATE_SUBSCRIPTION') {
    return '이미 웹 멤버십 예약이 신청되어 있습니다.';
  }

  return message || '웹 멤버십 예약 신청에 실패했습니다. 다시 시도해 주세요.';
};
